import React, { useEffect, useState } from "react";
import Title from "./../ReusableComponents/title";
import { MenuItem, Grid, createSvgIcon } from "@mui/material";
import "../../assets/css/Trademate.scss";
import Rating from "@mui/material/Rating";
import Select from "react-select";
import CKEditor from "./CKEditor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { ReactComponent as CrossBtn } from "../../assets/icons/NewIcons/exitIcon.svg";
import { customStyles } from "../../reusableComponents/MobileTabs/customstyle";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
const Empty = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.6875 17.8333L6.04167 11.9792L1.5 8.04167L7.5 7.52083L9.83333 2L12.1667 7.52083L18.1667 8.04167L13.625 11.9792L14.9792 17.8333L9.83333 14.7292L4.6875 17.8333Z"
      fill="#8F8F8F"
    />
  </svg>,
  "Home"
);

const Fill = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.85547 17.8333L6.20964 11.9792L1.66797 8.04167L7.66797 7.52083L10.0013 2L12.3346 7.52083L18.3346 8.04167L13.793 11.9792L15.1471 17.8333L10.0013 14.7292L4.85547 17.8333Z"
      fill="url(#paint0_radial_3910_88752)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3910_88752"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.87122 16.6154) rotate(-40.081) scale(21.517 57.562)"
      >
        <stop stop-color="#0D56EB" />
        <stop offset="1" stop-color="#0640B9" />
      </radialGradient>
    </defs>
  </svg>,
  "Home"
);

const parseDate = (date) => {
  // Return "2022-07-25";
  const dateIns = new Date(date);
  let month = dateIns.getMonth() + 1;
  if (month < 10) {
    month = `0${month.toString()}`;
  }
  return `${dateIns.getFullYear()}-${month}-${dateIns.getDate()}`;
};

const CreateTrader = (props) => {
  const { prefetchData } = props;
  const [Data, setData] = useState({
    date: (prefetchData && parseDate(prefetchData.date)) || null,
    symbol: (prefetchData && prefetchData.symbol) || "",
    trade_type: (prefetchData && prefetchData.action) || "Buy",
    entry: (prefetchData && prefetchData.entry) || "In",
    counter_trend: null,
    trigger: "",
    supporting_evidence: "",
    opposing_evidence: "",
    heads_up: "",
    notes: "",
    alerts_placed: null,
    order_price: (prefetchData && prefetchData.price) || "",
    profit: (prefetchData && prefetchData.profit.toString()) || "",
    max_stop_price: "",
    size: (prefetchData && prefetchData.size) || "",
    max_loss: "",
    technical_stop: "",
    exit_traget: "",
    time_stop: null,
    risk_or_reward: "",
    system_rules: 1,
    result_in_fear: 1,
    greed_or_pride: 1,
  });

  const [dateInput, setDateInput] = useState(Data?.date);

  const handleProfit = (e) => {
    e.preventDefault();
    setData({ ...Data, profit: e.target.value });
  };

  const handleEntry = (option) => {
    setEntryType(option);
    setData((prevData) => ({
      ...prevData,
      entry: option.value,
    }));
  };

  const handleReward = (e) => {
    e.preventDefault();
    setData({ ...Data, risk_or_reward: e.target.value });
  };
  const handleTimestop = (value) => {
    const formattedTime = dayjs(value).format("HH:mm"); // Format time to 24-hour format (e.g., "14:30")
    setData({ ...Data, time_stop: formattedTime });
  };

  const handleExitTarget = (e) => {
    e.preventDefault();
    setData({ ...Data, exit_traget: e.target.value });
  };
  const handleTechnicalStop = (e) => {
    e.preventDefault();
    setData({ ...Data, technical_stop: e.target.value });
  };
  const handleMaxLoss = (e) => {
    e.preventDefault();
    setData({ ...Data, max_loss: e.target.value });
  };
  const handleSize = (e) => {
    e.preventDefault();
    setData({ ...Data, size: e.target.value });
  };
  const handleMaxStop = (e) => {
    e.preventDefault();
    setData({ ...Data, max_stop_price: e.target.value });
  };
  const handleEntryOrder = (e) => {
    e.preventDefault();
    setData({ ...Data, order_price: e.target.value });
  };
  const handleHeadsUp = (e) => {
    e.preventDefault();
    setData({ ...Data, heads_up: e.target.value });
  };
  const handleDate = (e) => {
    const newDate = moment(e).format("YYYY-MM-DD");
    if (newDate) {
      setDateInput(newDate);
    }
    e.preventDefault();
    setData({ ...Data, date: dateInput });
  };
  const handleSymbol = (e) => {
    e.preventDefault();
    setData({ ...Data, symbol: e.target.value });
  };
  const handleType = (option) => {
    setTradeType(option);
    setData((prevData) => ({
      ...prevData,
      trade_type: option.value,
    }));
  };
  const handleTrigger = (e) => {
    e.preventDefault();
    setData({ ...Data, trigger: e.target.value });
  };
  const handleSupporting = (e) => {
    e.preventDefault();
    setData({ ...Data, supporting_evidence: e.target.value });
  };
  const handleOpposing = (e) => {
    e.preventDefault();
    setData({ ...Data, opposing_evidence: e.target.value });
  };

  const handleChange = (e) => {
    let radioopt = e.currentTarget.getAttribute("value");
    setData({ ...Data, alerts_placed: radioopt });
  };
  const handleChangeAlert = (e) => {
    let radioopt = e.currentTarget.getAttribute("value");
    setData({ ...Data, counter_trend: radioopt });
  };

  const handleCreateForm = (e) => {
    e.preventDefault();
    props.handleFormSubmit(Data);
    props.handleCross()
    console.log(props.handleCross(),"msdjkfhsuerbuwejrwer")
  };

  const [tradeType, setTradeType] = useState("");
  const [entryType, setEntryType] = useState("");

  const tradeTypeOptions = [
    { value: "Sell", label: "Sell" },
    { value: "Buy", label: "Buy" },
  ];
  const entryTypeOptions = [
    { value: "In", label: "In" },
    { value: "Out", label: "Out" },
  ];

  return (
    <div className="CreateTrader Container-p-20">
      <div className="headerWrapper">
        <Title six>Create Trade Journal</Title>
        <div className="crossBtnWrapper" style={{ cursor: "pointer" }}>
          <CrossBtn
            className="CreateTrader-crossIcon"
            onClick={(e) => {
              e.stopPropagation();
              props.handleCross();
            }}
          />
        </div>
      </div>

      <form onSubmit={handleCreateForm} className="trade-journal-form-wrapper">
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          className="Section mtt-20"
          spacing={2}
        >
          <Grid
            item
            xl={4}
            lg={4}
            xs={12}
            sm={12}
            className="Selectinput"
            style={{ maxHeight: "91px" }}
          >
            <Title three>Date</Title>

            {/* <input
              onChange={handleDate}
              defaultValue={Data.date}
              className="inputField"
              type="date"
              id="date"
            /> */}
            <DatePicker
              onChange={handleDate}
              value={dateInput}
              className="inputField"
              id="date"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Symbol</Title>
            <input
              onChange={handleSymbol}
              defaultValue={Data.symbol}
              className="inputField"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Trade Type</Title>
            <Select
              id="trade-select"
              className="react-select-container"
              classNamePrefix="react-select"
              value={tradeType}
              options={tradeTypeOptions}
              onChange={handleType}
              styles={customStyles(60)}
              isSearchable={false}
            />
          </Grid>
        </Grid>
        <div className="counterTrendChecboxWrapper">
          <Title seven>Is this a counter trend trade?</Title>
          <div className="checkBox">
            <div
              onClick={handleChangeAlert}
              className="d-flex gapp-10"
              value="Yes"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className={
                  "TraderRadio " +
                  (Data.counter_trend === "Yes" && "RadioSelected")
                }
              >
                <rect
                  x="1"
                  y="1"
                  width="14"
                  height="14"
                  rx="7"
                  fill="white"
                  fill-opacity="0.1"
                />
                <rect
                  x="1"
                  y="1"
                  width="14"
                  height="14"
                  rx="7"
                  stroke="#5E5E5E"
                  stroke-width="2"
                />
                <circle cx="8" cy="8" r="5" fill="#F6F6F6" />
              </svg>
              <Title four>Yes</Title>
            </div>
            <div
              onClick={handleChangeAlert}
              className="d-flex gapp-10"
              value="No"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className={
                  "TraderRadio " +
                  (Data.counter_trend === "No" && "RadioSelected")
                }
              >
                <rect
                  x="1"
                  y="1"
                  width="14"
                  height="14"
                  rx="7"
                  fill="white"
                  fill-opacity="0.1"
                />
                <rect
                  x="1"
                  y="1"
                  width="14"
                  height="14"
                  rx="7"
                  stroke="#5E5E5E"
                  stroke-width="2"
                />
                <circle cx="8" cy="8" r="5" fill="#F6F6F6" />
              </svg>
              <Title four>No</Title>
            </div>
          </div>
        </div>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          className="Section"
        >
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Trigger</Title>
            <input
              onChange={handleTrigger}
              defaultValue={Data.trigger}
              className="inputField textarea"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Supporting Evidence</Title>
            <input
              onChange={handleSupporting}
              defaultValue={Data.supporting_evidence}
              className="inputField textarea"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Opposing Evidence</Title>
            <input
              onChange={handleOpposing}
              defaultValue={Data.opposing_evidence}
              className="inputField textarea"
              type="text"
            />
          </Grid>
        </Grid>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          item
          className="Section mtt-20"
        >
          {" "}
          <Grid
            item
            lg={12}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingRight={"16px"}
          >
            <Title three>Heads up</Title>
            <input
              onChange={handleHeadsUp}
              defaultValue={Data.heads_up}
              className="inputField textarea"
              type="text"
            />
          </Grid>
        </Grid>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          item
          className="Section mtt-20"
        >
          <Grid
            item
            lg={6}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingRight={"16px"}
          >
            <Title three>Profit</Title>
            <input
              onChange={handleProfit}
              defaultValue={Data.profit}
              className="inputField"
              type="text"
            />
          </Grid>
          <Grid
            lg={6}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingTop={"16px"}
            paddingRight={"16px"}
          >
            <Title three>Entry</Title>
            <Select
              id="entry-select"
              value={entryType}
              options={entryTypeOptions}
              label="entry"
              className="react-select-container"
              classNamePrefix="react-select"
              onChange={handleEntry}
              styles={customStyles(60)}
              isSearchable={false}
            >
              <MenuItem className="selectOptionsBox" value="In">
                In
              </MenuItem>
              <MenuItem className="selectOptionsBox" value="Out">
                Out
              </MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          className="Section"
        >
          <Grid item container className="Section" lg={12} spacing={2}>
            <Grid
              item
              lg={6}
              sm={12}
              xs={12}
              spacing={1}
              className="Selectinput"
            >
              <Title seven>Entry Plan</Title>
              <Grid item className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Entry order price</Title>
                <input
                  onChange={handleEntryOrder}
                  defaultValue={Data.order_price}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Max stop price</Title>
                <input
                  onChange={handleMaxStop}
                  defaultValue={Data.max_stop_price}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Size</Title>
                <input
                  onChange={handleSize}
                  defaultValue={Data.size}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2}>
                <Title three>Max $ loss</Title>
                <input
                  onChange={handleMaxLoss}
                  defaultValue={Data.max_loss}
                  className="inputField"
                  type="text"
                />
              </Grid>
            </Grid>
            <Grid
              item
              lg={6}
              sm={12}
              xs={12}
              spacing={1}
              className="Selectinput"
            >
              <Title seven>Exit Plan</Title>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Technical Stop</Title>
                <input
                  onChange={handleTechnicalStop}
                  defaultValue={Data.technical_stop}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Exit target/Trigger</Title>
                <input
                  onChange={handleExitTarget}
                  defaultValue={Data.exit_traget}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid
                className="Selectinput dateTimeDiv"
                marginTop={2}
                marginBottom={2}
                onClick={(e) => e.stopPropagation()}
              >
                <Title three>Time stop</Title>
                {/* <input
                  onChange={handleTimestop}
                  defaultValue={Data.time_stop}
                  className="inputField"
                  type="time"
                /> */}
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  onClick={(e) => e.stopPropagation()}
                >
                  <TimePicker
                    onClick={(e) => e.stopPropagation()}
                    onChange={(value) => handleTimestop(value)}
                    value={
                      Data.time_stop ? dayjs(Data.time_stop, "HH:mm") : null
                    }
                    className="inputField timePicker"
                    ampm={false}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid className="Selectinput" marginTop={2}>
                <Title three>Est. Risk/Reward</Title>
                <input
                  onChange={handleReward}
                  defaultValue={Data.risk_or_reward}
                  className="inputField"
                  type="text"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid container item lg={12} className="Section">
          <Grid
            container
            item
            lg={12}
            className="Selectinput SectionNotes"
            paddingRight={"16px"}
          >
            <Title three>Notes/Insights/Results</Title>
            {
              <CKEditor
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setData({ ...Data, notes: data });
                  // this.setState({ content: editor.getData() });
                }}
              />
            }
            <textarea
              onChange={handleNotes}
              defaultValue={Data.notes}
              className="inputField"
              type="text"
              rows="10"
            />
          </Grid>
        </Grid> */}
        <div>
          <div className="orderPlacedBox">
            <Title seven>Orders/Alerts Placed?</Title>
            <div className="orderPlacedCheckbox">
              <div
                onClick={handleChange}
                className="d-flex gapp-10"
                value="Yes"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className={
                    "TraderRadio " +
                    (Data.alerts_placed === "Yes" && "RadioSelected")
                  }
                >
                  <rect
                    x="1"
                    y="1"
                    width="14"
                    height="14"
                    rx="7"
                    fill="white"
                    fill-opacity="0.1"
                  />
                  <rect
                    x="1"
                    y="1"
                    width="14"
                    height="14"
                    rx="7"
                    stroke="#5E5E5E"
                    stroke-width="2"
                  />
                  <circle cx="8" cy="8" r="5" fill="#F6F6F6" />
                </svg>
                <Title four>Yes</Title>
              </div>
              <div onClick={handleChange} className="d-flex gapp-10" value="No">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className={
                    "TraderRadio " +
                    (Data.alerts_placed === "No" && "RadioSelected")
                  }
                >
                  <rect
                    x="1"
                    y="1"
                    width="14"
                    height="14"
                    rx="7"
                    fill="white"
                    fill-opacity="0.1"
                  />
                  <rect
                    x="1"
                    y="1"
                    width="14"
                    height="14"
                    rx="7"
                    stroke="#5E5E5E"
                    stroke-width="2"
                  />
                  <circle cx="8" cy="8" r="5" fill="#F6F6F6" />
                </svg>
                <Title four>No</Title>
              </div>
            </div>
          </div>
        </div>
        <Grid
          lg={8}
          className="Section RatingContainer align-items-center"
          sx={{ gap: "2rem", flexWrap: "wrap" }}
        >
          <div className="headerBox" style={{ width: "100%" }}>
            <Title six>Rate yourself</Title>
          </div>

          <div className="ratingsBox">
            <div className="Selectinput">
              <Title seven>Follows system rules ?</Title>
              <Rating
                name="simple-controlled"
                icon={<Fill />}
                emptyIcon={<Empty />}
                value={Data.system_rules}
                onChange={(event, newValue) => {
                  setData({ ...Data, system_rules: newValue });
                }}
              />
            </div>
            <div className="Selectinput">
              <Title seven>Result in fear/anxiety ?</Title>
              <Rating
                name="simple-controlled"
                value={Data.result_in_fear}
                icon={<Fill />}
                emptyIcon={<Empty />}
                onChange={(event, newValue) => {
                  setData({ ...Data, result_in_fear: newValue });
                }}
              />
            </div>
            <div className="Selectinput">
              <Title seven>Spark ‘greed’ or ‘pride’ ?</Title>
              <Rating
                icon={<Fill />}
                emptyIcon={<Empty />}
                name="simple-controlled"
                value={Data.greed_or_pride}
                onChange={(event, newValue) => {
                  setData({ ...Data, greed_or_pride: newValue });
                }}
              />
            </div>
          </div>
        </Grid>
        <div className="text-align-center createJournalBtn">
          <button className="Button">Create Trade Journal</button>
        </div>
      </form>
    </div>
  );
};

export default CreateTrader;
